import React from 'react';
import { MarketProvider } from './contexts/MarketContext';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { Backing } from './components/Backing';
import { ForWhom } from './components/ForWhom';
import { BeforeAfter } from './components/BeforeAfter';
import { Solution } from './components/Solution';
import { WhatsIncluded } from './components/WhatsIncluded';
import { TransitionBanner } from './components/TransitionBanner';
import { Bundle } from './components/Bundle';
import { Bonuses } from './components/Bonuses';
import { Passport } from './components/Passport';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Faq } from './components/Faq';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { Footer } from './components/Footer';
const BEFORE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/3fc2bb1c-3e0f-4952-83f0-eea08ab0da04.jpg';
const AFTER_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/a25fcac6-df7c-4594-a5e3-580b20cfd42a.jpg';
export function App() {
  return <MarketProvider data-id="element-0" data-mp="3rcswxr1q28cu">
      <div className="w-full bg-cream font-sans" data-id="element-1" data-mp="3recc1ebn6dd1">
        <TopBar data-id="element-2" data-mp="4wvhonpuufq" />
        <main data-id="element-3" data-mp="5gez9t0lqvv">
          <Hero data-id="element-4" data-mp="56lhc8rh1lf" />
          <TrustStrip data-id="element-5" data-mp="7stfczkdj46" />
          <Backing data-id="element-6" data-mp="2zllff2q1qmn9" />
          <ForWhom data-id="element-7" data-mp="2zm4zaoz9bl3x" />
          <BeforeAfter beforeImage={BEFORE_IMAGE} afterImage={AFTER_IMAGE} data-id="element-8" data-mp="2zmo6pbra6r3p" />
          <Solution data-id="element-9" data-mp="33nq6put0v76q" />
          <WhatsIncluded data-id="element-10" data-mp="33n6xd2hftr4b" />
          <TransitionBanner data-id="element-11" data-mp="33oi1j3esp0vy" />
          <Bundle data-id="element-12" data-mp="38l8gtoirzsgb" />
          <Bonuses data-id="element-13" data-mp="38kqafz2efxuo" />
          <Passport data-id="element-14" data-mp="38k6wsujs7vmg" />
          <Testimonials data-id="element-15" data-mp="38o4fxg6d0n6c" />
          <Offer data-id="element-16" data-mp="3dkl0k0ecojeo" />
          <Faq data-id="element-17" data-mp="3dl4jnkfqldua" />
          <div id="final-cta" data-id="element-18" data-mp="3dlnsmbnesrw6">
            <FinalCTA data-id="element-19" data-mp="3dirxsw6uyjby" />
          </div>
        </main>
        <Footer data-id="element-20" data-mp="nuhh6fb985sp" />
        <StickyMobileCTA hideAtId="final-cta" data-id="element-21" data-mp="nv0ybtt2yq5o" />
      </div>
    </MarketProvider>;
}